import { render, staticRenderFns } from "./empty-card.vue?vue&type=template&id=6c17fe4c&"
import script from "./empty-card.vue?vue&type=script&lang=js&"
export * from "./empty-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports